export default __webpack_public_path__ + "static/avatar-5b9dc7f58b123a28ce74c796d6d0d30b.png";